import { useEffect, useRef, type ReactNode } from 'react'
import './DropdownMenu.css'

export interface MenuItem {
  icon?: ReactNode
  label: string
  onClick: () => void
  variant?: 'normal' | 'danger'
  divider?: boolean
}

interface DropdownMenuProps {
  isOpen: boolean
  onClose: () => void
  items: MenuItem[]
}

export function DropdownMenu({ isOpen, onClose, items }: DropdownMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isOpen) return

    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose()
      }
    }

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscape)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div ref={menuRef} className="menu-dropdown">
      {items.map((item, index) => (
        <div key={index}>
          {item.divider && <div className="menu-divider"></div>}
          <button
            onClick={() => {
              item.onClick()
              onClose()
            }}
            className={`menu-item ${item.variant === 'danger' ? 'delete-item' : ''}`}
          >
            {item.icon && <span className="menu-item-icon">{item.icon}</span>}
            {item.label}
          </button>
        </div>
      ))}
    </div>
  )
}
